/** @file World→clip rows from a Camera: worldToPixel, then pixel → NDC with y flipped (top-left origin). */
import type { Camera } from '@pose2d/geometry/types';

/**
 * Writes the 2x3 world→clip matrix as rows [ax, ay, a0, bx, by, b0] into out[0..5] and returns out:
 * clipX = ax·x + ay·y + a0, clipY = bx·x + by·y + b0. Pixel (0, 0) is clip (−1, 1); (W, H) is (1, −1).
 * The camera's width and height span the whole drawing buffer whatever its device-pixel size.
 */
export function clipTransform(out: Float32Array, camera: Camera): Float32Array {
  const m = camera.worldToPixel;
  const sx = 2 / camera.width;
  const sy = -2 / camera.height;
  out[0] = (m[0] ?? 0) * sx;
  out[1] = (m[1] ?? 0) * sx;
  out[2] = (m[4] ?? 0) * sx - 1;
  out[3] = (m[2] ?? 0) * sy;
  out[4] = (m[3] ?? 0) * sy;
  out[5] = (m[5] ?? 0) * sy + 1;
  return out;
}
